import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ShieldCheck, Lock, MessageCircle, Twitter, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0B3C5D] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-xl bg-white/10 backdrop-blur flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-[#00C853]" strokeWidth={2.5} />
              </div>
              <span className="font-display text-2xl font-bold">
                Gifto<span className="text-[#00C853]">pay</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-slate-300 max-w-sm leading-relaxed">
              The trusted global gift card exchange. Sell your unused gift cards safely and get
              paid instantly via PayPal, Crypto, Bank Transfer & more.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <div className="flex items-center gap-1.5 text-xs text-slate-300">
                <ShieldCheck className="w-4 h-4 text-[#00C853]" /> SSL Secured
              </div>
              <div className="flex items-center gap-1.5 text-xs text-slate-300">
                <Lock className="w-4 h-4 text-[#00C853]" /> 256-bit Encryption
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider mb-4 text-white/80">
              Product
            </h4>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li><Link to="/sell" className="hover:text-[#00C853]">Sell Gift Cards</Link></li>
              <li><Link to="/rates" className="hover:text-[#00C853]">Live Rates</Link></li>
              <li><Link to="/brands" className="hover:text-[#00C853]">All Brands</Link></li>
              <li><Link to="/dashboard" className="hover:text-[#00C853]">Dashboard</Link></li>
              <li><Link to="/proof" className="hover:text-[#00C853]">Proof of Payments</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider mb-4 text-white/80">
              Popular
            </h4>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li><Link to="/sell/amazon" className="hover:text-[#00C853]">Sell Amazon</Link></li>
              <li><Link to="/sell/apple" className="hover:text-[#00C853]">Sell Apple / iTunes</Link></li>
              <li><Link to="/sell/visa" className="hover:text-[#00C853]">Sell Visa</Link></li>
              <li><Link to="/sell/steam" className="hover:text-[#00C853]">Sell Steam</Link></li>
              <li><Link to="/sell/googleplay" className="hover:text-[#00C853]">Sell Google Play</Link></li>
              <li><Link to="/sell-in/us" className="hover:text-[#00C853]">Sell in the US</Link></li>
              <li><Link to="/sell-in/uk" className="hover:text-[#00C853]">Sell in the UK</Link></li>
              <li><Link to="/sell-in/ae" className="hover:text-[#00C853]">Sell in the UAE</Link></li>
              <li><Link to="/sell-in/ca" className="hover:text-[#00C853]">Sell in Canada</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider mb-4 text-white/80">
              Support
            </h4>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li><Link to="/faq" className="hover:text-[#00C853]">FAQ</Link></li>
              <li><a href="#whatsapp" className="hover:text-[#00C853]">Live Chat</a></li>
              <li><a href="mailto:support@giftopay.com" className="hover:text-[#00C853]">support@giftopay.com</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider mb-4 text-white/80">
              Legal
            </h4>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li><Link to="/terms" className="hover:text-[#00C853]">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-[#00C853]">Privacy Policy</Link></li>
              <li><Link to="/faq#aml" className="hover:text-[#00C853]">AML / KYC</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 items-center justify-between">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} Giftopay Financial Technologies. Available in US, UK, UAE
            & Canada.
          </p>
          <div className="flex items-center gap-3 text-slate-300">
            <a href="#twitter" aria-label="Twitter" className="hover:text-[#00C853]"><Twitter className="w-5 h-5" /></a>
            <a href="#facebook" aria-label="Facebook" className="hover:text-[#00C853]"><Facebook className="w-5 h-5" /></a>
            <a href="#instagram" aria-label="Instagram" className="hover:text-[#00C853]"><Instagram className="w-5 h-5" /></a>
            <a href="#whatsapp" aria-label="WhatsApp" className="hover:text-[#00C853]"><MessageCircle className="w-5 h-5" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
